/**
 * @file
 * Behaviors for oldie_brft.theme.
 */

(function ($, Drupal, settings) {

  /**
   * Oldie namespace.
   */
  Drupal.oldie = Drupal.oldie || {};

  /**
   * Behaviors for media entities.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.oldie_brft_media = {
    initAutoResize() {
      // Count eligible iframes.
      let entries = [
        'iframe.media-oembed-content',
        '.region-content .field--name-body iframe'
      ].join(', ');

      // If no matching element exists, do nothing.
      if ($(entries).length === 0) {
        return;
      }

      // Prepare resize handler.
      let callback = Drupal.debounce(
        function () {
          $(entries)
            .each(function () {
              let $iframe = $(this);
              let width = $iframe.width();
              let height = width / (16 / 9);
              $iframe.css('height', height);
            });
        },
        250
      );

      // Attach resize handler.
      window.addEventListener('resize', callback, {
        passive: true,
      });
      callback();
    },
    attach() {
      this.initAutoResize();
    }
  }

  /**
   * Foldable elements with a "continue reading" button.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.oldie_foldable = {
    attach: function (context, drupalSettings) {
      let entries = [
        '.js-foldable',
        '.field--name-field-lyrics .field__items'
      ].join(', ');
      $(entries)
        .each(function () {
          const FOLDABLE_HEIGHT = 250;
          let $el = $(this);

          // If the element is not tall enough, then do nothing.
          if ($el.height() <= FOLDABLE_HEIGHT) {
            return;
          }

          // Otherwise, restrict the element's height.
          $el.addClass('foldable foldable-folded').css({
            height: FOLDABLE_HEIGHT
          });

          // Prepare strings.
          var text_read_more = Drupal.t('Read more');
          var text_read_less = Drupal.t('Read less');

          // Add a "continue reading" button and fold the element ".folded".
          let $button = $('<button>' + text_read_more + '</button>')
            .attr({
              'type': 'button',
              'aria-hidden': true,
              'class': 'foldable__button button-unfold'
            })
            .click(function () {
              let $button = $(this);
              let $el = $button.prev('.foldable');

              // Unfold the foldable.
              if ($el.hasClass('foldable-folded')) {
                $button
                  .removeClass('button-unfold')
                  .addClass('button-fold')
                  .text(text_read_less);
                $el.removeClass('foldable-folded').css({
                  height: ''
                });
              }
              // Refold the foldable.
              else {
                $button
                  .removeClass('button-fold')
                  .addClass('button-unfold')
                  .text(text_read_more);
                $el.addClass('foldable-folded').css({
                  height: FOLDABLE_HEIGHT
                });
              }

              // Drupal.oldie.scrollToElement($el);
            });
          $el.after($button);
        });
    }
  };

})(jQuery, Drupal, drupalSettings);
